import { defineMessages } from 'react-intl';

export default defineMessages({
  newCustomer: {
    description: 'customerSummary.newCustomer',
    defaultMessage: 'New Customer',
    id: 'rz9LhR',
  },
  customerSince: {
    description: 'customerSummary.customerSince',
    defaultMessage: 'Customer since {created}',
    id: 'uDHyhU',
  },
  totalOrders: {
    description: 'customerSummary.totalOrders',
    defaultMessage: 'Total Orders',
    id: 'rsHjtN',
  },
  grossRevenue: {
    description: 'customerSummary.grossRevenue',
    defaultMessage: 'Gross Revenue',
    id: 'YDAUxe',
  },
  disclaimer: {
    description: 'customerSummary.disclaimer',
    defaultMessage: 'Activity from the last 12 months',
    id: 'w9Nukq',
  },
  error: {
    description: 'customerSummary.error',
    defaultMessage: 'Error loading customer',
    id: '/Y9TBg',
  },
  unavailable: {
    description: 'customer summary is not available',
    defaultMessage:
      'We have temporarily deactivated the customer history popover to decrease system load and keep shipment processing running smoothly.',
    id: 'ZWFkpj',
  },
  unavailableHeader: {
    description: 'customer summary is not available',
    defaultMessage: 'Temporarily Unavailable',
    id: '9KyXx8',
  },
});
